import { U } from "./lib/U";
import Dispatcher from "./models/Dispatcher";
import Uploader from "./models/Uploader";
import Chat from "./models/Chat";
import {
  bufToString,
  bufToString2,
  toArrayBuf,
  toBytesInt32
} from "./lib/helpers";
const serviceLocation = PRODUCTION
  ? "https://websocket.digitalbranch.nl"
  : "http://127.0.0.1:1337";
const socketLocation = PRODUCTION
  ? "wss://websocket.digitalbranch.nl"
  : "ws://127.0.0.1:1337";
const App = {
  user: null,
  ws: null,
  hasAvatar: false,
  sendTo: "all",
  contacts: [],
  files: [],
  DOM: {
    history: null,
    user: document.querySelector(".messenger > header .user"),
    messenger: document.querySelector(".messenger"),
    login: document.querySelector(".login"),
    msgs: document.querySelector(".msgs"),
    closeBtn: document.getElementById("close"),
    sendBtn: document.getElementById("send"),
    menuBtn: document.querySelector('[data-action="toggleMenu"]'),
    fileUpload: document.getElementById("attachment"),
    attachmentMenuBtn: document.querySelector(
      '[data-action="toggleAttachmentMenu"]'
    ),
    menu: document.querySelector(".menu"),
    attachmentMenu: document.querySelector(".attachmentmenu"),
    clearBtn: document.querySelector('[data-action="clearHistory"]'),
    chatsBtn: document.querySelector('[data-action="toggleChats"]'),
    msg: document.getElementById("msg"),
    form: document.getElementById("msgform"),
    main: document.querySelector(".main"),
    files: document.querySelector(".files"),
    contacts: document.querySelector(".contacts"),
    forms: {
      signin: document.getElementById("signin")
    }
  },
  createTimestamp() {
    let d = new Date();
    return (
      U.leadingZero(d.getDate()) +
      "-" +
      U.leadingZero(d.getMonth() + 1) +
      "-" +
      d.getFullYear() +
      " " +
      U.leadingZero(d.getHours()) +
      ":" +
      U.leadingZero(d.getMinutes())
    );
  },
  handleMessage: data => {
    if (data.type !== "connection") {
      App.saveMsg(data, true);
      let node = App.DOM.contacts.querySelector(
        `[data-user='${data.user}'] .msg`
      );
      if (data.sendTo !== "all" && data.sendTo !== App.sendTo) {
        let unread = parseInt(node.getAttribute("data-unread"), 10) + 1;
        let flag = data.sendTo === App.sendTo;
        node.textContent = data.data;
        node.setAttribute("data-read", flag);
        node.setAttribute("data-unread", !flag ? unread : 0);
        App.DOM.contacts
          .querySelector(`[data-user='${data.user}'] .count`)
          .setAttribute("aria-hidden", flag);
        App.DOM.contacts.querySelector(
          `[data-user='${data.user}'] .count`
        ).textContent = !flag ? unread : "";
      }
      if (
        data.user === App.sendTo ||
        (data.sendTo === "all" && App.sendTo === "all")
      ) {
        App.DOM.msgs.appendChild(App.createMsg(data, "recipient"));
        App.DOM.msgs.scrollTop =
          App.DOM.msgs.scrollHeight - App.DOM.msgs.clientHeight;
      }
    } else if (data.type === "connection") {
      if (data.msg === "new connection") {
        App.DOM.contacts.innerHTML = "";
        App.contacts = data.connections;
        data.connections.forEach((connection, i) => {
          let contact = U.createNewElement("div", [
            "class=contact vcenter flex flexrow",
            "data-action=selectcontact",
            `data-user=${connection[0]}`,
            "aria-pressed=false"
          ]);
          let avatar = U.createNewElement("div", [
            "class=avatar",
            'innerHTML=<i class="fas fa-user-circle"></i>'
          ]);
          let msg = U.createNewElement("div", ["class=msg", "data-unread=0"]);
          let username = U.createNewElement("span", [
            "class=username",
            `content=${connection[0]}`
          ]);
          let count = U.createNewElement("div", [
            "class=count",
            "aria-hidden=true"
          ]);
          if (connection[1]) {
            let reader = new FileReader();
            reader.addEventListener(
              "loadend",
              e => (avatar.style.backgroundImage = `url(${reader.result})`)
            );
            if (data.files && data.files[i]) {
              reader.readAsDataURL(data.files[i]);
              avatar.classList.add("image");
            }
          }
          App.DOM.contacts.appendChild(
            U.append(
              contact,
              avatar,
              U.append(
                U.createNewElement("div", ["class=wrapper flex flexcolumn"]),
                username,
                msg
              ),
              count
            )
          );
          contact.addEventListener("click", App.dispatcher.dispatch, false);
        });
      } else {
        data.connections.forEach(connection => {
          if (App.sendTo === connection[0]) {
            App.sendTo = "all";
            App.DOM.msgs.innerHTML = "";
            App.history.forEach(msg => {
              if (msg.sendTo === App.sendTo) {
                App.DOM.msgs.appendChild(
                  App.createMsg(msg, msg.recieved ? "recipient" : "sender")
                );
              }
            });
          } else {
            App.DOM.msgs.removeChild(
              App.DOM.msgs.querySelector(`[data-user='${connection[0]}']`)
            );
          }
          App.DOM.contacts.removeChild(
            App.DOM.contacts.querySelector(`[data-user='${connection[0]}']`)
          );
        });
      }
    }
  },
  parseFiles: data => {
    let files = [];
    let start = 0;
    let chunck;
    while (
      start < data.byteLength &&
      (chunck = data.slice(start)).byteLength !== 0
    ) {
      let size = new DataView(chunck.slice(0, 4)).getUint32(0);
      let type = bufToString2(chunck.slice(4, 20));
      // Snap niet waarom vier bytes extra moeten worden toegevoegd.
      let file = chunck.slice(20, size + 24);
      start += size + 24;
      if (file.byteLength > 0) {
        files.push(new Blob([file], { type: type }));
      }
    }
    return files;
  },
  message: e => {
    if (e.data instanceof Blob) {
      let reader = new FileReader();
      reader.addEventListener("loadend", e => {
        let result = bufToString(reader.result);
        if (result.data.files) {
          result.data.files = App.parseFiles(
            reader.result.slice(result.offset)
          );
        }
        App.handleMessage(result.data);
      });
      reader.readAsArrayBuffer(e.data);
    } else {
      App.handleMessage(JSON.parse(e.data));
    }
  },
  createMsg: (data, type) => {
    let wrapper = document.createElement("div");
    let user = document.createElement("span");
    let msg = document.createElement("span");
    let timestamp = document.createElement("span");
    user.className = "user";
    msg.className = "data";
    timestamp.className = "timestamp";
    wrapper.appendChild(user);
    wrapper.appendChild(msg);
    wrapper.appendChild(timestamp);
    wrapper.className = `flex flexcolumn msg ${type}`;
    wrapper.setAttribute("data-user", data.user);
    user.textContent = data.user;
    msg.textContent = data.data;
    timestamp.textContent = data.timestamp;
    console.log(data);
    if ("Notification" in window && type === "recipient") {
      if (Notification.permission === "granted") {
        App.notification = new Notification("SendIt", {
          body: `${data.user}: ${data.data}`
        });
      } else if (Notification.permission !== "denied") {
        Notification.requestPermission(function(permission) {
          if (permission === "granted") {
            App.notification = new Notification("SendIt", {
              body: `${data.user}: ${data.data}`
            });
          }
        });
      }
    }
    if (data.files) {
      data.files = Array.isArray(data.files) ? data.files : [data.files];
      let status = data.files.length;
      data.files.forEach(file => {
        let reader = new FileReader();
        reader.addEventListener("loadend", e => {
          let node;
          if (file.type.indexOf("image") > -1) {
            node = U.createNewElement("img", [`src=${reader.result}`]);
          } else {
            node = U.createNewElement("div", [`class=fas fa-file`]);
          }
          msg.appendChild(node);
          status -= 1;
          if (status === 0) {
            App.closeFiles();
          }
        });
        reader.readAsDataURL(file);
      });
    }
    return wrapper;
  },
  clearHistory: () => {
    localStorage.setItem("chathistory", JSON.stringify([]));
    App.history = [];
    App.DOM.msgs.innerHTML = "";
  },
  saveMsg: function(msg, recieved = false) {
    msg.recieved = recieved;
    App.history.push(msg);
    localStorage.setItem("chathistory", JSON.stringify(App.history));
  },
  send: (e, bool = true) => {
    let msg;
    if (e instanceof Event) {
      e.preventDefault();
      msg = App.DOM.msg.value;
    } else {
      msg = e;
    }
    let data = {
      user: App.user,
      data: msg,
      sendTo: App.sendTo,
      timestamp: App.createTimestamp(),
      files: App.files.length > 0,
      hasAvatar: App.hasAvatar
    };
    let q = [];
    const trottle = payload => {
      q.push(payload);
      const fn = () => {
        if (App.ws.bufferedAmount === 0 && q.length > 0) {
          App.ws.send(q.shift());
        } else {
          setTimeout(() => fn(), 0);
        }
      };
      fn();
    };
    App.DOM.msg.value = "";
    if (App.ws.readyState === 1) {
      let buf;
      if (data.files) {
        let bufData = new Uint8Array(toArrayBuf(JSON.stringify(data)));
        let length =
          App.files.reduce((a, b) => a + b.length, 0) + App.files.length * 4;
        let bufFiles = (function() {
          let tmp = new Uint8Array(length);
          let offset = 0;
          App.files.forEach(file => {
            tmp.set(file, offset);
            offset += file.byteLength;
          });
          return tmp;
        })();
        buf = new Uint8Array(bufData.length + length);
        buf.set(bufData);
        buf.set(bufFiles, bufData.length);
        data.files = Array.prototype.slice.call(App.DOM.fileUpload.files);
        App.files = [];
      } else {
        buf = toArrayBuf(JSON.stringify(data));
      }
      trottle(buf);
      if (bool) {
        App.DOM.msgs.appendChild(App.createMsg(data, "sender"));
        App.DOM.msgs.scrollTop =
          App.DOM.msgs.scrollHeight - App.DOM.msgs.clientHeight;
        App.saveMsg(data);
      }
    }
  },
  toggleMenu: e => {
    let state = App.DOM.menuBtn.getAttribute("aria-pressed");
    App.DOM.menuBtn.setAttribute(
      "aria-pressed",
      state === "true" ? false : true
    );
    App.DOM.menu.setAttribute("aria-hidden", state === "true");
  },
  toggleAttachmentMenu: e => {
    let state = App.DOM.attachmentMenuBtn.getAttribute("aria-pressed");
    App.DOM.attachmentMenuBtn.setAttribute(
      "aria-pressed",
      state === "true" ? false : true
    );
    App.DOM.attachmentMenu.setAttribute("aria-hidden", state === "true");
  },
  convertFiles: (files = App.DOM.fileUpload.files) => {
    let status = files.length;
    U.forEach(files, file => {
      let reader = new FileReader();
      reader.addEventListener(
        "load",
        e => {
          status -= 1;
          let buf = new Uint8Array(reader.result);
          let type = new Uint8Array(
            toArrayBuf(
              file.type.split("/")[0] +
                "/" +
                file.name.match(/\.[^.]+$/)[0].replace(".", ""),
              "Uint8",
              16
            )
          );
          let size = toBytesInt32(buf.byteLength);
          let tmp = new Uint8Array(
            reader.result.byteLength + type.byteLength + size.byteLength
          );
          tmp.set(size);
          tmp.set(type, 4);
          tmp.set(buf, 20);
          App.files.push(tmp);
          if (status === 0) {
            App.DOM.sendBtn.disabled = false;
          }
        },
        false
      );
      reader.readAsArrayBuffer(file);
    });
  },
  closeFiles: e => {
    App.files = [];
    App.DOM.files.setAttribute("aria-hidden", true);
    App.DOM.files.querySelector(".container").innerHTML = "";
    App.DOM.fileUpload.value = "";
  },
  uploadFile: e => {
    let status = e.target.files.length;
    U.forEach(e.target.files, file => {
      let reader = new FileReader();
      reader.addEventListener(
        "load",
        e => {
          status -= 1;
          let node;
          if (file.type.indexOf("image") > -1) {
            node = U.createNewElement("img", [`src=${reader.result}`]);
          } else {
            node = U.createNewElement("div", [`class=fas fa-file`]);
          }
          U.append(App.DOM.files.querySelector(".container"), node);
          if (status === 0) {
            App.DOM.files.setAttribute("aria-hidden", false);
            App.toggleAttachmentMenu();
            App.files = [];
            App.convertFiles();
          }
        },
        false
      );
      if (file.type.indexOf("image") > -1) {
        reader.readAsDataURL(file);
      } else {
        reader.readAsText(file);
      }
    });
  },
  init: () => {
    // App.chat = new Chat({
    //   target: document.body,
    //   id: "main",
    //   user: {},
    //   url: socketLocation
    // });
    App.dispatcher = new Dispatcher({
      event: "selectcontact",
      callback: (e, target) => {
        let sendTo = target.getAttribute("data-user");
        if (sendTo === App.sendTo) {
          target.setAttribute("aria-pressed", false);
          sendTo = "all";
        } else {
          U.forEach(App.DOM.contacts.children, contact =>
            contact.setAttribute("aria-pressed", false)
          );
          target.setAttribute("aria-pressed", true);
          target.querySelector(".msg").setAttribute("data-read", true);
          target.querySelector(".msg").setAttribute("data-unread", 0);
          target.querySelector(".count").setAttribute("aria-hidden", true);
        }
        App.sendTo = sendTo;
        App.DOM.msgs.innerHTML = "";
        App.history.forEach(msg => {
          if (msg.sendTo === App.sendTo || msg.user === App.sendTo)
            App.DOM.msgs.appendChild(
              App.createMsg(msg, msg.recieved ? "recipient" : "sender")
            );
        });
        App.DOM.messenger.querySelector(".body").classList.remove("showchats");
      }
    });
    App.DOM.forms.signin.querySelector(".avatarupload").appendChild(
      new Uploader({
        id: "avatar",
        name: "avatar",
        maxSize: 200,
        buttonText: "Avatar",
        multiple: false,
        allowed: ["jpg", "gif", "png"],
        label: "",
        load: function(e) {
          let that = this;
          if (that.status === "done") {
            if (that.result) {
              App.DOM.user.querySelector(".avatar").classList.add("image");
              App.DOM.user.querySelector(
                ".avatar"
              ).style.backgroundImage = `url(${that.result})`;
              App.hasAvatar = true;
            }
            if (that.uploader.files.length > 0) {
              App.convertFiles(that.uploader.files);
            }
          }
        }
      })
    );
    App.DOM.forms.signin.addEventListener(
      "submit",
      e => {
        e.preventDefault();
        let username = e.target.elements.username;
        App.user = username.value;
        U.http
          .post({
            url: `${serviceLocation}/join`,
            data: `username=${App.user}`
          })
          .then(res => {
            let error = App.DOM.login.querySelector(".error");
            if (res.exists) {
              username.setAttribute("aria-invalid", true);
              if (!error) {
                U.insertAfter(
                  U.createNewElement("span", [
                    "content=Username already in use",
                    "class=error"
                  ]),
                  username
                );
              }
            } else {
              App.DOM.user.querySelector(".username").textContent = App.user;
              if (error) {
                username.setAttribute("aria-invalid", false);
                username.parentNode.removeChild(error);
              }
              U.showHide(
                App.DOM.login,
                {
                  action: "hide",
                  style: "fade"
                },
                () => {
                  U.showHide(
                    App.DOM.messenger,
                    {
                      action: "show",
                      style: "fade"
                    },
                    () => App.initMessenger()
                  );
                }
              );
            }
          });
      },
      false
    );
  },
  initMessenger: () => {
    App.clearHistory();
    App.history = JSON.parse(localStorage.getItem("chathistory")) || [];
    App.history.forEach(msg => {
      if (msg.sendTo === App.sendTo || msg.user === App.sendTo)
        App.DOM.msgs.appendChild(
          App.createMsg(msg, msg.recieved ? "recipient" : "sender")
        );
    });
    App.DOM.msgs.scrollTop =
      App.DOM.msgs.scrollHeight - App.DOM.msgs.clientHeight;
    App.DOM.attachmentMenuBtn.addEventListener(
      "click",
      App.toggleAttachmentMenu,
      false
    );
    App.DOM.menuBtn.addEventListener("click", App.toggleMenu, false);
    App.DOM.fileUpload.addEventListener("change", App.uploadFile, false);
    App.DOM.files
      .querySelector("header")
      .addEventListener("click", App.closeFiles, false);
    App.ws = new WebSocket(`${socketLocation}`);
    App.ws.onopen = e => {
      window.addEventListener(
        "focus",
        e => {
          if (App.sendTo !== "all") {
            App.DOM.contacts
              .querySelector(`[data-user='${App.sendTo}']`)
              .querySelector(".msg")
              .setAttribute("data-read", true);
            App.DOM.contacts
              .querySelector(`[data-user='${App.sendTo}']`)
              .querySelector(".msg")
              .setAttribute("data-unread", 0);
            App.DOM.contacts
              .querySelector(`[data-user='${App.sendTo}']`)
              .querySelector(".count")
              .setAttribute("aria-hidden", true);
          }
        },
        false
      );
      App.send("new connection", false);
      App.DOM.closeBtn.addEventListener("click", e => App.close(), false);
      App.DOM.form.addEventListener("submit", e => App.send(e), false);
      App.DOM.msg.addEventListener(
        "input",
        e => {
          if (App.DOM.msg.value.length > 0) {
            App.DOM.sendBtn.disabled = false;
          } else {
            App.DOM.sendBtn.disabled = true;
          }
        },
        false
      );
      App.DOM.clearBtn.addEventListener(
        "click",
        e => {
          App.clearHistory();
          App.toggleMenu();
        },
        false
      );
      App.DOM.chatsBtn.addEventListener(
        "click",
        e => {
          App.DOM.messenger
            .querySelector(".body")
            .classList.toggle("showchats");
          App.toggleMenu();
        },
        false
      );
    };
    App.ws.onmessage = App.message;
    App.ws.onclose = e => {
      console.log(e);
    };
    App.ws.onerror = e => {
      console.log(e);
    };
  }
};
App.init();
